var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dialog-v2',{attrs:{"argument":_vm.dialog}},[_c('b-form-v2',{attrs:{"form":_vm.dialog.form,"form-items":_vm.dialog.form.formItems,"form-data":_vm.dialog.form.data},on:{"cancel":_vm.cancel,"enter":_vm.enter,"response":_vm.response}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }